// B1.5 thin facade: `@/lib/api` → index → client (mixins only).
export * from './api/index';
